// Environment-based configuration
export const config = {
  // PostHog configuration
  posthog: {
    enabled: import.meta.env.PROD,
    apiKey: import.meta.env.VITE_POSTHOG_KEY,
    apiHost: import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com',
  },
  
  // API configuration
  api: {
    url: import.meta.env.VITE_API_URL || 'https://localhost:5001/api',
  },
  
  // Environment info
  env: {
    isDev: import.meta.env.DEV,
    isProd: import.meta.env.PROD,
    mode: import.meta.env.MODE,
  }
}

// Helper function to check if PostHog should be used
export const isPostHogEnabled = () => {
  return config.posthog.enabled && config.posthog.apiKey
}

export const isSophieHost = () => {
  const href = window.location.href;
  return href.includes('heysophie') || href.includes('localhost');
}